<template lang="html">
  <div id="about-us" class="conteiner">
    <div class="row">
      <div class="col-lg-3 sidebar">
        <div></div>
      </div>
      <div class="col-lg-9 col-sm-12 text-left">
        <SmallHeader/>
        <div class="about-us-container row">
          <h3><a @click="$router.go(-1)"><img class="img-responsive" src="../assets/img/icons/back-button.svg" alt="Back Button"></a>{{translation.aboutUs.about}}</h3>
          <div class="col-sm-12 col-sm-block mobile-image">
            <img class="img-responsive" src="../assets/img/backgrounds/Za-Nas_mobile.jpg" alt="">
          </div>
          <div class="margin-par">
            {{translation.aboutUs.firstParagraf}}
          </div>
          <div>
            {{translation.aboutUs.firstParagraf1}}
          </div>
          <div class="margin-par">
            {{translation.aboutUs.firstParagraf2}}
          </div>
          <div>
            {{translation.aboutUs.firstQuestion}}
          </div>
          <div>
            {{translation.aboutUs.fiveQuestion}}
          </div>
          <div>
            {{translation.aboutUs.secondQuestion}}
          </div>
          <div>
            {{translation.aboutUs.thirdQuestion}}
          </div>
          <div class="margin-par">
            {{translation.aboutUs.fourtQuestion}}
          </div>
          <div class="margin-par">
            <p>{{translation.aboutUs.secondParagraf3}}</p>
            {{translation.aboutUs.secondParagraf}}
          </div>
          <div class="margin-par">
            {{translation.aboutUs.secondParagraf2}}
          </div>
          <div>
            {{translation.aboutUs.thirtParagraf}}
          </div>
          <div>
            {{translation.aboutUs.thirtParagraf1}}
          </div>
          <div>
            {{translation.aboutUs.thirtParagraf2}}
          </div>
          <Footer/>
        </div>
        <div class="grey-paw">
          <img class="img-responsive" src="../assets/img/icons/grey-paws.svg" alt="Paw">
        </div>
      </div>
    </div>
    <Cookies/>
  </div>
</template>

<script>
import SmallHeader from '../components/SmallHeader.vue'
import Footer from '../components/Footer.vue'
import Cookies from '../components/Cookies.vue'
export default {
  data(){
    return {
      translation: message
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
  },
  components: {
    SmallHeader,
    Footer,
    Cookies
  }
}
</script>

<style>
.about-us-container {
  width: 70%;
  color: #fff;
  margin-top: 3em;
  margin-left: 3em;
}
#about-us .mobile-image{
  display: none;
}
#about-us{
  position: relative;
}
#about-us .sidebar div{
  background-image: url('../assets/img/backgrounds/Za-Nas_sait.jpg');
}
.grey-paw{
  position: absolute;
  right: 0;
  top: 50%;
}
#app {
  background: linear-gradient(to bottom, #3057b0 0%, #4377c5 100%);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
  min-height: 100%;
  min-width: 100%;
}
#about-us .margin-par{
  margin-bottom: 1em;
}
@media (max-width: 1024px) {
  .grey-paw{
    display: none;
  }
  #about-us .mobile-image{
    display: block;
  }
  .about-us-container{
    width: 100%;
    margin: 0;
  }
}
@media (max-width: 768px) {

  .about-us-container {
    margin-top: 2em;
    width: 95%;
    margin-left: 0;
    margin: 0 auto;
  }
 }
 @media (max-width: 600px) {
   .about-us-container{
     width: 91%;
     margin-top: 1em;
   }
 }
</style>
